import React, { createContext, ReactNode, useState } from 'react';
import { IDistrict, IRegisteredUser, ISMResponse } from '../models';
import api from '../utils/api';
import Cookies from 'js-cookie';

interface IUserContext extends IRegisteredUser {
    logout: (all: boolean) => Promise<void>;
    adminAccess: boolean;
    userAdministrativeAreas: string[];
}

export interface ISMContext {
    user: IUserContext | undefined;
    fetchUser: () => Promise<void>;
    polygons: undefined;
    polygonsNamed: IDistrict[];
    loadingScreenVisible?: boolean;
    setLoadingScreenVisible: (visible: boolean) => void;
}

export const SprawneMiastoContext = createContext<ISMContext | undefined>(undefined);

export default function UserContextProvider(props: { children: ReactNode }) {
    const [user, setUser] = useState<IUserContext | undefined>(undefined);
    const [polygons, setPolygons] = useState<undefined>(undefined);
    const [polygonsNamed, setPolygonsNamed] = useState<IDistrict[]>([]);
    const [loadingScreenVisible, setLoadingScreenVisible] = useState<boolean | undefined>(
        undefined,
    );

    async function fetchUser() {
        const auth = Cookies.get('sm_auth');
        if (!auth) return setUser(undefined);
        const response = await api.get('users/me');
        if (!response.ok) return setUser(undefined);
        const responseJSON = (await response.json()) as ISMResponse<{
            user: IRegisteredUser;
        }>;
        if (responseJSON.status === 'success')
            setUser({
                logout: logout,
                userAdministrativeAreas: responseJSON.data.user.admin.concat(
                    responseJSON.data.user.moderator,
                ),
                adminAccess:
                    responseJSON.data.user.moderator.length > 0 ||
                    responseJSON.data.user.admin.length > 0,
                ...responseJSON.data.user,
            });
    }

    async function logout(all: boolean) {
        const response = await api.post('auth/token/revoke', {
            body: JSON.stringify({ all: all }),
        });
        if (!response.ok) return;
        Cookies.remove('sm_auth');
        setUser(undefined);
    }

    return (
        <SprawneMiastoContext.Provider
            value={{
                polygonsNamed,
                user,
                fetchUser,
                polygons,
                loadingScreenVisible,
                setLoadingScreenVisible,
            }}>
            {props.children}
        </SprawneMiastoContext.Provider>
    );
}
